import { Component } from 'react'
import { connect } from 'react-redux'
import { localized } from 'decorators'
import { isNull } from 'utils/isNotNull'
import { getAccessToken } from 'utils/accessToken'
import { userManager } from 'auth/userManager'
import { redirectToReturnUrl } from 'utils/redirectTo'

class LoginPage extends Component {
  redirectIfNeeded = () => {
    const accessToken = getAccessToken()
    if (isNull(accessToken)) {
      userManager.signinRedirect()
    } else {
      redirectToReturnUrl()
    }
  }
  componentDidUpdate (prevProps) {
    if (prevProps.oidc.isLoadingUser === true && this.props.oidc.isLoadingUser === false) { this.redirectIfNeeded() }
  }
  componentDidMount () {
    if (this.props.oidc.isLoadingUser === false) {
      this.redirectIfNeeded()
    }
  }
  render () { return null }
}

export default localized(connect(({ oidc }) => ({ oidc }))(LoginPage))
